import styled from 'styled-components';

export const Bold = styled.span`
  font-weight: 700;
`;

export const PaginatorInfoWrapper = styled.div`
  color: ${(props) => props.theme.colors.gray[70]};
`;
